import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { paths } from 'src/app/Shared/enums/paths.enum';
import { CommonService } from 'src/app/Shared/services/common_services/common.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoaderindicatorService } from 'src/app/Shared/services/loaderindicator/loaderindicator.service';
import { DataCommunicationService } from 'src/app/Shared/services/data_service/data-communication.service';
import { TranslateService } from '@ngx-translate/core';

declare var gtag;
@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.css']
})
export class OtpVerificationComponent implements OnInit {
  public otpVerificationForm: FormGroup;
  ShowResendOtp = false;
  mobilnummer: string;
  encryptedmobilnummer: string;
  IsSubmitted = false;
  currentData: any;
  showError = false;
  dealernName: string;
  dealerImage: any;
  managerName: any;
  @ViewChild('OTPFirstInput') OTPFirstInput: ElementRef;
  AppointmentSource: any;
  SelectedDealerName: any;
  constructor(
    private commonService: CommonService,
    private loadingIndicatorService: LoaderindicatorService,
    private dataCommunicationService: DataCommunicationService,
    protected readonly fb: FormBuilder,
    private translate: TranslateService
  ) { 
    if(this.commonService.getLocalStorageitem('SelectedVehicleLicensePlate')!=null)
    {
      this.commonService.NavigatePage(paths.BOOKAPPOINTMENT, 'Drammen');
    }
  }

  public verifyOTP() {
    this.showError = false;
    this.IsSubmitted = true;
    if (this.otpVerificationForm.invalid) {
      return;
    }
    const otpvalue = this.otpVerificationForm.value.otp1 +
      this.otpVerificationForm.value.otp2 +
      this.otpVerificationForm.value.otp3 +
      this.otpVerificationForm.value.otp4;
    const UserOTPViewModel = {};
    UserOTPViewModel['OTPCode'] = otpvalue;
    UserOTPViewModel['Mobile'] = this.mobilnummer;
    UserOTPViewModel['guid'] = this.commonService.getLocalStorageitem('otpguid');
    UserOTPViewModel['DealerName'] = this.commonService.getLocalStorageitem('dealername');
    this.translate.get('LoaderText.VerifyOTP').subscribe(message => {
      this.loadingIndicatorService.show(message);
    });
    // to remove below comment in main application all comments
    this.dataCommunicationService.verifyMobileOTP(UserOTPViewModel).subscribe(
      result => {

        this.loadingIndicatorService.hide();
        if (result.StatusCode === 1 || result.StatusCode === 3) {
          if (result.Data.VerifyResult === true) {
            if (result.Data.DelaerNumber != 0) {
              this.commonService.setLocalStorage('dealername', result.Data.DelaerNumber);
              this.commonService.removeLocalStorage(['otpguid']);
              this.showError = false;
              this.PushDataToAnalytics('success');
              this.commonService.NavigatePage(paths.CARLIST);
            } else {
              // this.commonService.NavigatePage(paths.CARLIST);
              this.commonService.getErrorMessage('Common.CommonText.label.InvalidDealer');
            }
          } else {
            this.showError = true;
            this.PushDataToAnalytics('fail');
            // this.commonService.getErrorMessage('LoaderText.InvalidOTP');
          }
        } else {
          this.PushDataToAnalytics('fail');
        }
      }, error => {
        this.PushDataToAnalytics('fail');
        this.commonService.getErrorMessage('LoaderText.AlertMsg');

      });

  }
  public loadotpForm() {
    this.otpVerificationForm = this.fb.group({
      otp1: [null, [Validators.required, Validators.maxLength(2)]],
      otp2: [null, [Validators.required, Validators.maxLength(2)]],
      otp3: [null, [Validators.required, Validators.maxLength(2)]],
      otp4: [null, [Validators.required, Validators.maxLength(2)]],
    });
  }
  public reSendOTP() {
    this.showError = false;
    this.dataCommunicationService.getMobileOTP(this.mobilnummer, this.dealernName, this.AppointmentSource).subscribe(
      result => {
        if (result.StatusCode === 1) {
          this.ShowResendOtp = false;
          this.delay(60000).then(() => {
            this.resendOtpbutton();
          });
        } else {
          //  this.toastrService.error(String(result.message));
          this.commonService.getErrorMessage('LoaderText.AlertMsg');
        }
      }
    );
  }
  public resendOtpbutton() {
    this.ShowResendOtp = true;
  }
  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(() => resolve(), ms)).then(x => x);
  }
  public PushDataToAnalytics(value) {
    gtag('event', 'OtpValidation', {'so-result': value});
  }
  public MobileNoChanged() {
    this.showError = false;
  }
  ngOnInit() {
    this.IsSubmitted = false;
    this.mobilnummer = this.commonService.getLocalStorageByKey('customerData', 'MobileNo');
    this.dealernName = this.commonService.getLocalStorageitem('dealername');
    this.dealerImage = this.commonService.getLocalStorageitem('dealerImage');
    this.managerName =  this.commonService.getLocalStorageitem('managerName');
    this.AppointmentSource = this.commonService.getLocalStorageitem("AppointmentSource");
    this.SelectedDealerName = this.commonService.getLocalStorageitem("SelectedDealerName");
    if (this.mobilnummer !== null && this.mobilnummer !== undefined && this.mobilnummer.trim() !== '' && this.mobilnummer.trim() !== '0') {
      this.encryptedmobilnummer = this.mobilnummer;
      this.loadotpForm();
      this.delay(60000).then(() => {
        this.resendOtpbutton();
      });
      this.OTPFirstInput.nativeElement.focus();
    } else {
      this.commonService.NavigatePage(paths.BOOKAPPOINTMENT);
    }
  }
}
